export const locale = {
    lang: 'ar',
    data: {
        EDIT_PARAGRAPHE: 'تحرير فقرة',
        TITLE: 'عنوان',
        SAVE: 'حفظ',
        CANCEL: 'إلغاء',
    }
};
